// extracted by mini-css-extract-plugin
module.exports = {"desktopView":"_2mzgjRX","phoneView":"_pBQTfAC","gameTitle":"_1LJydoI","gameInfo":"_3pdW8Ve","gameTitleHide":"_2HNE_np","gameButton":"_bhG1nia","gameInfoSh":"_NTM1Enx"};